module.exports = __webpack_public_path__ + "static/media/team-test-test-test-test.710cb8f7.png";